/* Favorites - guest wishlist (Downsized Designs / Canyon). Product-level only: stores product handles in localStorage. */
(function () {
  'use strict';
  var KEY = 'dd_favorites';
  var FETCH_TIMEOUT_MS = 8000;
  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function paint() {
    var list = read();
    document.querySelectorAll('[data-fav-toggle]').forEach(function (btn) {
      var h = btn.getAttribute('data-handle');
      var on = !!h && list.indexOf(h) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = btn.getAttribute('aria-label') || '';
      var lm = lbl.match(/^(?:Add|Remove)\s+(.+?)\s+(?:to|from) favorites$/);
      if (lm) btn.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + lm[1] + (on ? ' from favorites' : ' to favorites'));
    });
    document.querySelectorAll('[data-fav-count]').forEach(function (badge) {
      badge.textContent = list.length;
      if (list.length > 0) { badge.removeAttribute('hidden'); } else { badge.setAttribute('hidden', ''); }
    });
  }
  function toggle(handle) {
    if (typeof handle !== 'string' || !handle) return;
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list); paint();
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function fetchProduct(handle) {
    var url = '/products/' + encodeURIComponent(handle) + '.js';
    var controller = null;
    var timeoutId = null;
    try {
      if (typeof AbortController !== 'undefined') {
        controller = new AbortController();
        timeoutId = setTimeout(function () { try { controller.abort(); } catch (e) {} }, FETCH_TIMEOUT_MS);
      }
    } catch (e) { controller = null; }
    var opts = { headers: { 'Accept': 'application/json' } };
    if (controller) opts.signal = controller.signal;
    return fetch(url, opts)
      .then(function (r) { if (!r.ok) throw new Error('missing'); return r.json(); })
      .then(function (p) {
        if (timeoutId) clearTimeout(timeoutId);
        if (!p || typeof p !== 'object') throw new Error('bad-data');
        return { handle: handle, p: p };
      })
      .catch(function () { if (timeoutId) clearTimeout(timeoutId); return null; });
  }
  function nameFromBtn(btn) {
    var label = (btn && btn.getAttribute('aria-label')) || '';
    var m = label.match(/^(?:Add|Remove)\s+(.+?)\s+(?:to|from) favorites$/);
    return m ? m[1] : '';
  }
  function announceFav(name, added) {
    if (window.ddAnnounce && name) window.ddAnnounce((added ? 'Added ' : 'Removed ') + name + (added ? ' to favorites.' : ' from favorites.'));
  }
  function renderPage() {
    var grid = document.querySelector('[data-fav-grid]');
    if (!grid) return;
    var status = document.querySelector('[data-fav-status]');
    function setStatus(msg) { if (status) status.textContent = msg; }
    var empty = document.querySelector('[data-fav-empty]');
    var loading = document.querySelector('[data-fav-loading]');
    function showLoading(on) {
      if (loading) { if (on) { loading.removeAttribute('hidden'); } else { loading.setAttribute('hidden', ''); } }
    }
    function showEmpty(on) {
      if (empty) { if (on) { empty.removeAttribute('hidden'); } else { empty.setAttribute('hidden', ''); } }
    }
    var list = read();
    grid.innerHTML = '';
    if (!list.length) {
      showLoading(false);
      showEmpty(true);
      setStatus('You have no favorites yet.');
      return;
    }
    showEmpty(false);
    showLoading(true);
    setStatus('Loading your favorites.');
    var alive = [];
    Promise.all(list.map(fetchProduct)).then(function (items) {
      var html = '';
      items.forEach(function (item) {
        if (!item || !item.p) return;
        var p = item.p;
        alive.push(item.handle);
        try {
          var url = '/products/' + esc(item.handle);
          var img = p.featured_image ? '<img src="' + esc(p.featured_image) + '" alt="" loading="lazy">' : '';
          var compare = (p.compare_at_price && p.compare_at_price > p.price) ? ' <s class="fav-card__compare">' + money(p.compare_at_price) + '</s>' : '';
          var firstVariant = p.variants && p.variants.length ? p.variants[0] : null;
          var addBtn = (firstVariant && firstVariant.id) ? '<button type="button" class="button button--secondary" data-fav-add="' + firstVariant.id + '">Add to cart</button>' : '';
          html += '<li class="fav-card">' +
            '<a class="fav-card__media" href="' + url + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
            '<div class="fav-card__info">' +
            '<h3 class="fav-card__title"><a href="' + url + '">' + esc(p.title) + '</a></h3>' +
            '<div class="fav-card__price"><span>' + money(p.price) + '</span>' + compare + '</div>' +
            '<div class="fav-card__actions">' +
            '<a class="button" href="' + url + '">View product</a>' +
            addBtn +
            '<button type="button" class="button button--tertiary" data-fav-remove data-handle="' + esc(item.handle) + '">Remove</button>' +
            '</div></div></li>';
        } catch (e) { /* skip unrenderable item */ }
      });
      write(alive);
      grid.innerHTML = html;
      showLoading(false);
      if (!alive.length) { showEmpty(true); setStatus('You have no favorites yet.'); }
      else setStatus('Showing ' + alive.length + (alive.length === 1 ? ' favorite.' : ' favorites.'));
      paint();
    }).catch(function () {
      showLoading(false);
      showEmpty(true);
      setStatus('Your favorites could not be loaded. Please try again.');
      paint();
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fav-toggle]');
    if (t) { var h = t.getAttribute('data-handle'); if (h) { var nm = nameFromBtn(t); var wasOn = read().indexOf(h) !== -1; toggle(h); announceFav(nm, !wasOn); } return; }
    var rm = e.target.closest('[data-fav-remove]');
    if (rm) { var rh = rm.getAttribute('data-handle'); if (rh) { var card = rm.closest('.fav-card'); var rt = card && card.querySelector('.fav-card__title a') ? card.querySelector('.fav-card__title a').textContent.trim() : ''; toggle(rh); renderPage(); announceFav(rt, false); var h1 = document.querySelector('.favorites-page h1'); if (h1) h1.focus(); } return; }
    var add = e.target.closest('[data-fav-add]');
    if (add) {
      var vid = add.getAttribute('data-fav-add');
      if (!vid) return;
      add.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
        .then(function (r) { if (!r.ok) throw new Error('add-failed'); add.textContent = 'Added to cart'; if (window.ddAnnounce) { var card = add.closest('.fav-card'); var tt = card && card.querySelector('.fav-card__title a') ? card.querySelector('.fav-card__title a').textContent.trim() : ''; window.ddAnnounce('Added to cart' + (tt ? ': ' + tt : '') + '.'); } setTimeout(function () { add.disabled = false; add.textContent = 'Add to cart'; }, 2000); })
        .catch(function () { add.disabled = false; if (window.ddAnnounce) window.ddAnnounce('Sorry, that item could not be added to the cart.'); });
    }
  });
  function init() { paint(); renderPage(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
